/* React Redux */
import React, { Component, PropTypes } from 'react'
import { parseTime, equals, secondsToObject} from 'util/datetime'
import { pad } from 'util/string'

/* Utilities */
import _ from 'lodash'
import moment from 'moment'

import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

import Caret from 'assets/dropdown-caret.svg'

/* Styles */
import './index.css'

export default class DurationInput extends Component {

  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      value: props.value,
      input: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value === nextProps.value) return
    this.setState({ value: nextProps.value })
  }


  hasChanged() {
    return !(this.state.value === this.props.value )
  }

  isValid() {
    const { validate } = this.props
    const { value } = this.state
    return !validate || validate(value)
  }

  getInputClassName() {
    if (!this.isValid()) return 'user-input invalid'
    return 'user-input'
  }

  getClassName() {
    const {
      className
    } = this.props
    let classNameArr = className ?className.split(' '):[]
    classNameArr.push('duration-input', 'widget')
    if (this.hasChanged()) classNameArr.push('changed')
    return  classNameArr.join(' ')
  }

  save() {
    if (!this.isValid()) return
    if (this.props.onSave) this.props.onSave(this.state.value)
    this.setState({ input: null })
    this.inputElement.blur()
  }

  reset() {
    if (this.props.onReset) this.props.onReset()
    this.setState({ value: this.props.defaultValue || null, input: null })
  }

  undo() {
    if (this.props.onUndo) this.props.onUndo()
    this.setState({ value: this.props.value, input: null })
    this.inputElement.blur()
  }

  cancel() {
    if (this.props.onCancel) this.props.onCancel()
    this.inputElement.blur()
  }

  incrementHours() {
    let time = this.state.value || 0
    time += 3600
    this.setState({ value: time, input: null })
  }

  decrementHours() {
    let time = this.state.value || 0
    if (time < 3600) return
    time -= 3600
    this.setState({ value: time, input: null })
  }

  incrementMinutes() {
    let time = this.state.value || 0
    time += 60
    this.setState({ value: time, input: null })
  }

  decrementMinutes() {
    let time = this.state.value || 0
    if (time < 60) return
    time -= 60
    this.setState({ value: time, input: null })
  }

  incrementSeconds() {
    let time = this.state.value || 0
    time++
    this.setState({ value: time, input: null })
  }

  decrementSeconds() {
    let time = this.state.value || 0
    if (time<1) return
    time--
    this.setState({ value: time, input: null })
  }

  onFocus(e) {
    this.setState({ edit: true })
    if (this.props.onEdit) this.props.onEdit()
  }

  onBlur(e) {
    this.setState({ edit: false })
  }

  onKeyDown(e) {
    switch (e.keyCode) {
      case 13: // enter
        e.preventDefault()
        e.stopPropagation()
        this.save()
        break
      case 27: // esc
        e.preventDefault()
        e.stopPropagation()
        this.cancel()
        break
    }
  }

  onChange(e) {
    let result
    const input = e.target.value
    this.setState({input:input})
    try {
      result = parseTime(input)
    } catch(e) {
      //console.warn(e)
    }
    if(result) this.setState({value:result})
  }

  onClick(e) {
    if (!this.state.edit) return // only during edit state
    e.stopPropagation()
    e.preventDefault()
  }

  onDragStart(e) {
    if (!this.state.edit) return // only during edit state
    e.stopPropagation()
    e.preventDefault()
  }

  onDragOver(e) {
    if (!this.state.edit) return // only during edit state
    //e.stopPropagation()
    e.dataTransfer.dropEffect='none'
    e.preventDefault()
  }

  onDragEnter(e) {
    if (!this.state.edit) return // only during edit state
    //e.stopPropagation()
    e.dataTransfer.dropEffect='none'
    e.preventDefault()
  }

  onDrop(e) {
    e.dataTransfer.dropEffect='none'
    e.preventDefault()
    if (!this.state.edit) return // only during edit state
    //e.stopPropagation()
  }

  onMouseDown(e) {
    e.preventDefault()
  }

  onButtonMouseDown(e) {
    // stop focus loss
    e.stopPropagation()
    e.preventDefault()
  }

  onSaveButtonClick(e) {
    e.stopPropagation()
    e.preventDefault()
    this.save()
  }

  onResetButtonClick(e) {
    e.stopPropagation()
    e.preventDefault()
    this.reset()
  }

  onUndoButtonClick(e) {
    e.stopPropagation()
    e.preventDefault()
    this.undo()
  }

  renderSaveButton() {
    const {
      edit
    } = this.state
    const {
      saveTitle
    } = this.props
    if (edit && this.hasChanged() && this.isValid()) {
      return (
        <button
          tabIndex="-1"
          onClick={ this.onSaveButtonClick.bind(this) }
          onMouseDown={ this.onButtonMouseDown.bind(this) }
          title={ saveTitle }
        >
          <Icon icon={ ICON.SAVE } size={ 24 }/>
        </button>
      )
    }
  }

  renderUndoButton() {
    const {
      edit
    } = this.state
    const {
      resetTitle
    } = this.props
    if (edit && this.hasChanged()) {
      return (
        <button
          tabIndex="-1"
          onClick={ this.onUndoButtonClick.bind(this) }
          onMouseDown={ this.onButtonMouseDown.bind(this) }
          title={ resetTitle }
        >
          <Icon icon={ ICON.UNDO } size={ 24 }/>
        </button>
      )
    }
  }

  renderResetButton() {
    const {
      edit
    } = this.state
    const {
      clearTitle
    } = this.props
    if (edit) {
      return (
        <button
          tabIndex="-1"
          onClick={ this.onResetButtonClick.bind(this) }
          onMouseDown={ this.onButtonMouseDown.bind(this) }
          title={ clearTitle }
        >
          <Icon icon={ ICON.DELETETEXT } size={ 24 }/>
        </button>
      )
    }
  }

  renderLabel() {
    const { label, labelWidth } = this.props
    if (!label) return null
    var style = (!labelWidth)?{}:{width: labelWidth+"px"}
    return (
      <div className="inputLabel" style={ style }>{ label }</div>
    )
  }

  renderInputToolbar() {
    return (
      <div className="toolbar">
        { this.renderSaveButton() }
        { this.renderUndoButton() }
        { this.renderResetButton() }
      </div>
    )
  }

  renderUpButton(onMouseDown) {
    return (
      <button
        className="increment-button"
        tabIndex="-1"
        onMouseDown={ (e)=>{ this.onButtonMouseDown(e); onMouseDown(e) } }
      >
        <Icon icon={ ICON.CARET_UP } size={ 16 } interactive={ false }/>
      </button>
    )
  }

  renderDownButton(onMouseDown) {
    return (
      <button
        className="decrement-button"
        tabIndex="-1"
        onMouseDown={  (e)=>{ this.onButtonMouseDown(e); onMouseDown(e) } }
      >
        <Icon icon={ ICON.CARET_DOWN } size={ 16 } interactive={ false }/>
      </button>
    )
  }

  renderParserResult() {
    const {
      value,
      edit
    } = this.state
    if (!edit) return null
    const time = secondsToObject(value || 0)
    return (
      <div className="date-picker">
        <div className="icon-wrapper"><Caret/></div>
        <div className="stepper-wrapper">
          <div className="date-group">
            <button
              className="increment-button"
              tabIndex="-1"
              onMouseDown={
                (e)=>{ this.onButtonMouseDown(e); this.incrementHours() }
              }
            >
              <Icon icon={ ICON.CARET_UP } size={ 16 } interactive={ false }/>
            </button>
            <div className="date-display">{ pad(time.hours, 2) }</div>
            <button
              className="decrement-button"
              tabIndex="-1"
              onMouseDown={
                (e)=>{ this.onButtonMouseDown(e); this.decrementHours() }
              }
            >
              <Icon icon={ ICON.CARET_DOWN } size={ 16 } interactive={ false }/>
            </button>
          </div>
          <div className="date-delimiter">:</div>
          <div className="date-group">
            <button
              className="increment-button"
              tabIndex="-1"
              onMouseDown={
                (e)=>{ this.onButtonMouseDown(e); this.incrementMinutes() }
              }
            >
              <Icon icon={ ICON.CARET_UP } size={ 16 } interactive={ false }/>
            </button>
            <div className="date-display">{ pad(time.minutes, 2) }</div>
            <button
              className="decrement-button"
              tabIndex="-1"
              onMouseDown={
                (e)=>{ this.onButtonMouseDown(e); this.decrementMinutes() }
              }
            >
              <Icon
                icon={ ICON.CARET_DOWN }
                size={ 16 }
                interactive={ false }
              />
            </button>
          </div>
          <div className="date-delimiter">:</div>
          <div className="date-group">
            <button
              className="increment-button"
              tabIndex="-1"
              onMouseDown={
                (e)=>{ this.onButtonMouseDown(e); this.incrementSeconds() }
              }
            >
              <Icon icon={ ICON.CARET_UP } size={ 16 } interactive={ false }/>
            </button>
            <div className="date-display">{ pad(time.seconds, 2) }</div>
            <button
              className="decrement-button"
              tabIndex="-1"
              onMouseDown={
                (e)=>{ this.onButtonMouseDown(e); this.decrementSeconds() }
              }
            >
              <Icon
                icon={ ICON.CARET_DOWN }
                size={ 16 }
                interactive={ false }
              />
            </button>
          </div>
        </div>
      </div>
    )
  }

  getInputValue() {
    const {
      edit,
      value,
      input
    } = this.state
    if(_.isString(input)) return input
    if(_.isNumber(value)) {
      var timeObj = secondsToObject(value)
      var str = pad(timeObj.hours, 2) + ":" +
        pad(timeObj.minutes, 2) + ":" +
        pad(timeObj.seconds, 2)
      if (timeObj.milliseconds) str += "." + pad(timeObj.milliseconds, 3)
      return str
    }
    return ""
  }

  render() {
    const {
        title,
        placeholder,
        labelWidth,
        disabled

    } = this.props
    const {
        edit,
        value,
        input
    } = this.state
    var style = (!labelWidth)?{}:{minWidth: (110+labelWidth).toString() + "px"}
    return (
      <div
        className={ this.getClassName() }
        onDragStart={ this.onDragStart.bind(this) }
        onDrop={ this.onDrop.bind(this) }
        onDragOver={ this.onDragOver.bind(this) }
        onDragEnter={ this.onDragEnter.bind(this) }
        onClick={ this.onClick.bind(this)}
        style={ style }
      >
        <div className="toolbar-wrapper">
          { this.renderLabel() }
          <div className="input-wrapper">
            <input
              type="text"
              title={ title }
              disabled={ disabled }
              value={ this.getInputValue() }
              ref={ (elem) => { this.inputElement = elem } }
              placeholder={ placeholder }
              className={ this.getInputClassName() }
              onKeyDown={ this.onKeyDown.bind(this) }
              onChange={ this.onChange.bind(this) }
              onFocus={ this.onFocus.bind(this) }
              onBlur={ this.onBlur.bind(this) }
              />
              <div className="overlay-wrapper">
                { this.renderParserResult() }
              </div>
          </div>
          { this.renderInputToolbar() }
        </div>
      </div>
    )
  }
}

DurationInput.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  labelWidth: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.number,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func,
  onUndo: PropTypes.func,
  onSave: PropTypes.func,
  onEdit: PropTypes.func,
  validate: PropTypes.func,
  disabled: PropTypes.bool,
  saveTitle: PropTypes.string,
  resetTitle: PropTypes.string,
  clearTitle: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/app/widget/duration-input/index.jsx